import ProductPage from "../Components/Products/ProductPage";
import AllProducts from "../Components/Products/AllProducts";
import LandingPage from "../Pages/LandingPage";
import UserAccount from "../Authentication/UserAccount";
import WishList from "../Pages/WishList";
import ContactUs from "../Pages/ContactUs";
import AboutUs from "../Pages/AboutUs";
import TermsAndConditions from "../Pages/TermsAndConditions";
import ShippingPolicy from "../Pages/ShippingPolicy";
import CancellationPolicy from "../Pages/CancellationPolicy";
import DateCalendarValue from "../Sub/Calendar";
import Monthly from "../Sub/Monthly";
import Weekly from "../Sub/Weekly";
import Plan from "../Sub/Plan";
import Wallet from "../Sub/Wallet";
import Save from "../Sub/Save";
import SubscriptionVerticalTabs from "../Sub/Subscription";

const routes = [
  {
    id: 1,
    path: "/",
    element: <LandingPage />,
  },
  {
    id: 2,
    path: "/home",
    element: <LandingPage />,
  },
  {
    id: 3,
    path: "/product/:id",
    element: <ProductPage />,
  },
  {
    id: 4,
    path: "/all-products",
    element: <AllProducts />,
  },
  {
    id: 5,
    path: "/user-account",
    element: <UserAccount />,
  },
  {
    id: 6,
    path: "/wish-list",
    element: <WishList />,
  },
  {
    id: 7,
    path: "/contact-us",
    element: <ContactUs />,
  },
  {
    id: 8,
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    id: 9,
    path: "/terms-and-policy",
    element: <TermsAndConditions />,
  },
  {
    id: 10,
    path: "/shipping-policy",
    element: <ShippingPolicy />,
  },
  {
    id: 11,
    path: "/cancellation-policy",
    element: <CancellationPolicy />,
  },
  {
    id: 12,
    path: "/calendar/:id/:variant_id",
    element: <DateCalendarValue />,
  },
  {
    id: 13,
    path: "/monthly/:id/:variant_id",
    element: <Monthly />,
  },
  {
    id: 14,
    path: "/weekly/:id/:variant_id",
    element: <Weekly />,
  },
  {
    id: 15,
    path: "/plan/:variant_id",
    element: <Plan />,
  },
  {
    id: 16,
    path: "/wallet",
    element: <Wallet />,
  },
  {
    id: 16,
    path: "/save",
    element: <Save />,
  },
  {
    id: 17,
    path: "/subscription",
    element: <SubscriptionVerticalTabs />,
  },
];
export default routes;
